<template>
  <div class="multi-select">
    <el-select
      ref="areaSelectRef"
      style="width: 100%"
      @change="changeSelect"
      placeholder="请选择地区"
      collapse-tags
      clearable
      multiple
      filterable
      v-model="bindValue"
      v-bind="bindProps"
      :filter-method="filterArea"
      @visible-change="visibleChange"
    >
      <el-option v-if="!searchValue" label="全选" value="all"></el-option>
      <el-option v-if="!searchValue" label="全不选" value="none"></el-option>
      <el-option
        v-for="item in selectOptions"
        :label="item[labelKey]"
        :value="item[valueKey]"
        :key="item[valueKey]"
      >
        <template>
          <span style="float: left">{{ item[[labelKey]] }}</span>
          <span style="float: right; color: #8492a6; font-size: 13px">{{
            item[[showKey]]
          }}</span>
        </template>
      </el-option>
    </el-select>
  </div>
</template>

<script>
import { removeSelectReadonly } from "@/utils/tool.js";

export default {
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    optionsList: {
      type: Array,
      default: () => [],
    },
    bindProps: Object,
    labelKey: {
      type: String,
      default: "name",
    },
    showKey: {
      type: String,
      default: "geo",
    },
    valueKey: {
      type: String,
      default: "paramGeo",
    },
  },
  data() {
    return {
      bindValue: this.value,
      selectOptions: [],
      searchValue: "",
    };
  },

  computed: {},

  watch: {
    value: {
      handler(val) {
        this.bindValue = val;
      },
      deep: true,
    },
    optionsList: {
      handler(val) {
        this.selectOptions = val;
      },
      deep: true,
    },
  },

  created() {},

  methods: {
    changeSelect() {
      // 点击全选
      if (
        this.bindValue[this.bindValue.length - 1] === "all" ||
        (this.bindValue.indexOf("all") !== -1 &&
          this.bindValue.length === this.optionsList.length)
      ) {
        this.bindValue = this.optionsList
          .map((item) => item[this.valueKey])
          .filter((child) => child !== "HW");
      }
      if (this.bindValue.indexOf("all") > -1 && this.bindValue.length > 1) {
        this.bindValue.splice(this.bindValue.indexOf("all"), 1);
      }
      // 全选排除 “海外”
      if (this.bindValue[this.bindValue.length - 1] === "HW") {
        this.bindValue = ["HW"];
      }
      // “海外”选中，选择别的，取消“海外”选中
      if (this.bindValue.indexOf("HW") > -1 && this.bindValue.length > 1) {
        this.bindValue.splice(this.bindValue.indexOf("HW"), 1);
      }
      if (this.bindValue.indexOf("none") > -1) {
        this.bindValue = [];
      }
      this.$emit("update:value", this.bindValue);
    },
    visibleChange(val) {
      if (!val) {
        removeSelectReadonly(this.$refs.areaSelectRef);
      }
    },
    filterArea(value) {
      this.searchValue = value;
      if (value) {
        this.selectOptions = this.optionsList.filter((item) => {
          return (
            (item[this.labelKey] + "")
              .toLowerCase()
              .indexOf(value.toLowerCase()) >= 0 ||
            (item[this.valueKey] + "")
              .toLowerCase()
              .indexOf(value.toLowerCase()) >= 0 ||
            (item[this.showKey] + "")
              .toLowerCase()
              .indexOf(value.toLowerCase()) >= 0
          );
        });
      } else {
        this.selectOptions = this.optionsList;
      }
    },
  },
};
</script>

<style lang="less" scoped></style>
